import { useDispatch } from "react-redux";
import API from "../../Network/API";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function TutorEarning(){
     const { t } = useTranslation();
     
     const dispatch = useDispatch();
     const [data,setData]=useState()

        useEffect(() => {
            
            API.get(`/v1/oauth/teacher/earning_history`).then((response) => {
                setData(response.data.data)
            }).catch((error) => {
            });
    
        }, []);

    return (
        <>
         <div className="dashboard-title">
                <h4>{t("tutorEarning.earning_history")}</h4>
            </div>
            <div className="row">
            <div className="col-12">
            <div className="table-responsive custom-table">
                                <table className="table table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>{t("tutorEarning.date")}</th>
                                            <th>{t("tutorEarning.course")}</th>
                                            <th>{t("tutorEarning.lesson")}</th>
                                            <th>{t("tutorEarning.earning")}</th>
                                            <th>{t("tutorEarning.fee")}</th>
                                            <th>{t("tutorEarning.clearance")}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                    {!data?.loading && data?.courses?.length > 0 && data?.courses?.map((course, j) => (
                                        <tr key={j}>
                                            <td data-label={t("tutorEarning.date")}>{course.created_at}</td>
                                            <td data-label={t("tutorEarning.course")}>{course.course_name}</td>
                                            <td data-label={t("tutorEarning.lesson")}>{course.lesson_name}</td>
                                            <td data-label={t("tutorEarning.earning")}>{course.earning}</td>
                                            <td data-label={t("tutorEarning.fee")}>{course.fees}</td>
                                            <td data-label={t("tutorEarning.clearance")}>{course?.approved==1? <span className="status-badge ok">{t("tutorEarning.approved")}</span> : <span className="status-badge pending">{t("tutorEarning.pending")}</span>}</td>
                                        </tr>
                                     ))}
                                    </tbody>
                                    </table>
                                    </div>
                </div>
                </div>
        </>
    )
}